import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import { OrganizationForm } from "../ProjectUnitModal/OrganizationForm";

export const OrganizationUpdateModal = ({
  modalState,
  toggleModal,
  translate,
  defaultValues,
  handleSubmit,
}) => {
  const validationSchema = Yup.object().shape({
    organization: Yup.object().shape({
      description: Yup.string().required("Required"),
      longDescription: Yup.string().required("Required"),
      legalRepresentativeName: Yup.string().required("Required"),
      legalRepresentativeSurname: Yup.string().required("Required"),
    }),
  });

  return (
    <Modal isOpen={modalState} toggle={() => toggleModal(false)}>
      <ModalHeader>{translate("organizationUnit.modalHeader")}</ModalHeader>
      {defaultValues && (
        <Formik
          initialValues={defaultValues}
          onSubmit={(values) => handleSubmit(values)}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <OrganizationForm
                  translate={translate}
                  defaultValues={defaultValues}
                  isUpdateProcess
                />
              </ModalBody>
              <ModalFooter>
                <Button type="submit">{translate("submitOrganization")}</Button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      )}
    </Modal>
  );
};
